<template>
  <div class="layout-wrapper">
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <div
      class="alert-wrapper"
      :class="!isQuoteResultPage ? 'mx-3 mx-xl-0' : 'mx-0 mx-md-4 mx-xl-0'"
    >
      <BaseAlert
        color="var(--orange-100)"
        class="quote-expired-message"
        v-if="isExpired"
      >
        <div class="d-flex flex-no-wrap error-message">
          <div class="mr-3">
            <v-icon color="var(--orange-500)">mdi-alert</v-icon>
          </div>
          <div>
            <span class="font-weight-bold">Sorry!</span> This quote has expired.
            Please check all the details below are accurate and submit a new
            quote.
          </div>
        </div>
      </BaseAlert>
      <QuoteErrorAlert v-if="showError" :isQuotationStage="isQuestionSteps" />
    </div>

    <div
      :class="
        !isQuoteResultPage
          ? 'b2b-tc-journey__container white rounded-lg elevation-3 mx-3 mt-3 mx-xl-0'
          : 'mt-3 quote-result__container'
      "
    >
      <router-view ref="routerView" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";

import QuoteErrorAlert from "@/components/QuoteErrorAlert.vue";
import BaseStepper from "@/components/BaseComponents/BaseStepper.vue";

import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "TenantsContentsLayout",
  components: {
    BaseStepper,
    QuoteErrorAlert,
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Property details",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.PROPERTY_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quotes",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.QUOTATION_RESULT,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: "Your application ",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: ROUTE_NAME.TENANTS_CONTENTS.B2B.COMPLETE,
        },
      ],
      isDrawerOpen: false,
    };
  },
  created() {
    // Listen for validation errors globally
    EventBus.$on("validation-error", handleValidationError);
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "isExpired",
      "isQuestionSteps",
      "isQuoteResultPage",
      "hasQuotes",
    ]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![ROUTE_NAME.TENANTS_CONTENTS.B2B.COMPLETE].includes(
        this.currentRouteName
      );
    },
    showError() {
      return (
        this.$route.name != ROUTE_NAME.TENANTS_CONTENTS.B2B.QUOTATION_RESULT ||
        this.hasQuotes
      );
    },
  },
  methods: {
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>

<scss lang="scss">
.layout-wrapper {
  max-width: 1080px;
}
.b2b-tc-journey__container {
  padding: 24px 16px 40px 16px !important;
  .radio-group__wrapper {
    max-width: 400px;
  }
}

.quote-result__container,
.b2b-tc-journey__container {
  margin-bottom: 40px;
}

@media screen and (min-width: $grid-breakpoints-sm) {
  .b2b-tc-journey__container {
    padding: 40px !important;
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .b2b-tc-journey__container {
    padding: 40px 40px 80px 40px !important;
  }
  .quote-result__container,
  .b2b-tc-journey__container {
    margin-bottom: 80px !important;
  }
  .quote-result__container {
    .quote,
    .quote-lowest-price,
    .quote-summary__card {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
  .alert-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</scss>
